import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../../../../common/api";
import {
  removeLoginInfo,
  removeCurrentInfo,
} from "../../../../features/mobile/commonSlice";
import { onResetQuestionComplete } from "../../../../features/mobile/otherSlice";
import HeadCont from "../../components/common/HeadCont";
import Dialog from "../../components/common/Dialog";

const Account = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [openDialog, setOpenDialog] = useState(false);

  const datas = [
    {
      id: 1,
      subMenu: [
        {
          id: 1,
          title: t('account.change_password'),
          titleKey: 'change_password',
          onAction: () => navigate("/account/editpass"),
        },
        {
          id: 2,
          title: t('account.profile_management'),
          onAction: () => navigate("/account/profile"),
        },
        { id: 3, title: t('account.logout'), onAction: () => setOpenDialog(true) },
        { id: 4, title: t('account.withdraw'), onAction: () => navigate("/resign") },
      ],
    },
  ];
  console.log(loginInfo);
  const onLogout = () => {
    // 로그아웃 - 백엔드에서 토큰 삭제(자동로그인 못하게)
    api
      .get(`/user/logout/${loginInfo.userId}`)
      .then((res) => {
        if (res.data.ok) {
          const timer = setTimeout(() => navigate("/sign"), 1000);
          dispatch(removeLoginInfo());
          dispatch(removeCurrentInfo());
          dispatch(onResetQuestionComplete());
          return () => clearTimeout(timer);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <HeadCont rightIcon={"no icon"} transparent={"on"} title={t('account.title')} />
      <section className="mb-6 mt-14">
        {datas.map((data) => (
          <div key={data.id} className="p-4 ">
            <ul>
              {data.subMenu.map((menu) => {
                if (
                  menu.titleKey === 'change_password' &&
                  loginInfo.existPass === false
                ) {
                  return;
                } else {
                  return (
                    <li
                      onClick={menu.onAction}
                      key={menu.id}
                      className={
                        "flex justify-between rounded-md p-3 active:bg-gray_20"
                      }
                    >
                      <h2 className="text-body3_700 text-gray_180">
                        {menu.title}
                      </h2>
                      <img
                        src="/images/mobile/icon/right.svg"
                        alt={t('icons.more')}
                      />
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        ))}
      </section>
      {openDialog && (
        <Dialog
          innerClass={"p-4"}
          title={t('account.logout')}
          desc={t('account.logout_confirm')}
          leftBtnTitle={t('account.stay_logged_in')}
          rightBtnTitle={t('account.yes')}
          onLeftBtnAction={() => setOpenDialog(false)}
          onRightBtnAction={onLogout}
          onCoverAction={() => setOpenDialog(false)}
        />
      )}
    </>
  );
};

export default Account;
